import { Controller, useForm } from "react-hook-form";
import AxiosInstance from "../../../AxiosInstance";
import { alertError } from "../../Helper/Alerts";
import { useMediaQuery } from "react-responsive";
import {
  documentAccpetedTypes,
  documentWidget,
  iDocumentStages,
} from "../../../utils/constants";
import {
  banksListController,
  countriesListController,
  insurerListController,
  statesListController,
} from "../../Helper/provider";
import { useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { uploadProfileDocumentToAWS } from "../../Helper/uploadDocument";
import { DatePicker, Divider, Select } from "antd";
import { AllowedProfileEditStatus } from "../../../constants";
import { Option } from "antd/es/mentions";
import {
  genderOptions,
  industryTypeOptions,
  occupationOptions,
} from "../../../utils/dropDownOptions";
import { getBankAccountType } from "../../../utils";
import VerifyPanModal from "../../../components/Model/VerifyPanModal";
import moment from "moment";
import dayjs from "dayjs";

export default function PartnerEntityRegistration({ userData }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
    setValue,
    getValues,
    reset,
  } = useForm({ mode: "onChange" });

  const navigate = useNavigate();
  // const [panDoc, setpanDoc] = useState();
  // const [aadharDoc, setaadharDoc] = useState();
  // const [cancelledChecqDoc, setcancelledChecqDoc] = useState();
  const [orgMemoDocument, setOrgMemoDoc] = useState();
  const [orgPanDocument, setorgPanDocument] = useState();
  const [orgRegistrationDocument, setorgRegistrationDocument] = useState();
  const [orgLossDocument, setorgLossDocument] = useState();
  const [orgIncomeDocument, setorgIncomeDocument] = useState();
  const [orgBalanceSheetDocument, setorgBalanceSheetDocument] = useState();
  const [orgAddressDocument, setorgAddressDocument] = useState();

  const [insurer, setInsurer] = useState([]);
  const [countries, setCountries] = useState([]);
  const [bankList, setBankList] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [existingUser, setExistingUser] = useState(false);
  const [profileData, setProfileData] = useState(userData);
  const { state } = useLocation();
  const [isCompany, setIsCompany] = useState(false);
  const [isOrgPanVerified, setIsOrgPanVerified] = useState(false);

  const [verifyOrgPanModalState, setVerifyOrgPanModalState] = useState(false);
  const [verifyPanModalState, setVerifyPanModalState] = useState(false);
  const [isPanVerified, setIsPanVerified] = useState(false);
  const [verifyAadhaarModalState, setVerifyAadhaarModalState] = useState(false);
  const [isAadhaarVerified, setIsAadhaarVerified] = useState(false);
  // const isMobile = useMediaQuery({ query: "(max-width: 750px)" });

  const [documentHill, setDocumentHill] = useState({
    orgMemoDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgMemoDocument",
    },
    orgPanDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgPanDocument",
    },
    orgRegistrationDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgRegistrationDocument",
    },
    orgIncomeDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgIncomeDocument",
    },
    orgLossDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgLossDocument",
    },
    orgBalanceSheetDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgBalanceSheetDocument",
    },
    orgAddressDocument: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "orgAddressDocument",
    },
    panDoc: { status: iDocumentStages.NOT_PICKED, url: "", key: "panDoc" },
    aadharDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "aadharDoc",
    },
    cancelledChecqDoc: {
      status: iDocumentStages.NOT_PICKED,
      url: "",
      key: "cancelledChecqDoc",
    },
  });
  // useEffect(() => {
  //   console.log("use Effect", documentHill);
  // }, [documentHill]);

  useEffect(() => {
    getSpinnerData();
    getProfileDataNew();
  }, []);
  const occupationChange = (value) => {
    setValue("occupation", value);
  };
  const getProfileDataNew = async () => {
    if (userData) setProfileData(userData);

    // let profileData = {};
    // const result = await AxiosInstance()
    //   .get(`/user/me`)
    //   .catch((error) => {});
    // profileData = result.data;
    // setProfileData(result.data);
    // if (profileData.userType === "ENTITY") {
    //   setIsCompany(true);
    //   return;
    // }

    if (profileData) {
      console.log(profileData);
      // if (profileData.insurerId) setValue("insurerId", profileData.insurerId);
      if (profileData.isPanVerified && profileData.pan) {
        // pan field will be disable only if pan number is also available
        setValue("pan", profileData.pan);
        setIsPanVerified(true);
        console.log("pan verified");
      }
      if (profileData.pan) {
        setValue("pan", profileData.pan);
      }
      if (profileData.firstName) {
        setValue("firstName", profileData.firstName);
      }
      if (profileData.lastName) {
        setValue("lastName", profileData.lastName);
      }
      if (profileData.isAadhaarVerified && profileData.aadhar) {
        // aadhaar field will be disable only if pan number is also available
        setIsAadhaarVerified(true);
      }
      if (profileData.aadhar) {
        setValue("aadhar", profileData.aadhar);
      }
      if (profileData.gender) setValue("gender", profileData.gender);
      if (profileData.address) setValue("address", profileData.address);
      if (profileData.occupation)
        setValue("occupation", profileData.occupation);
      if (profileData.city) setValue("city", profileData.city);
      if (profileData.countryId) {
        countryChange(profileData.countryId);
      }
      if (profileData.stateId) {
        stateChange(profileData.stateId);
      }
      if (profileData.pinCode) setValue("pinCode", profileData.pinCode);
      if (profileData.bankAccountNumber)
        setValue("bankAccountNumber", profileData.bankAccountNumber);
      if (profileData.bankId) {
        bankNameChange(profileData.bankId);
      }
      if (profileData.accountType) {
        accountTypeChange(profileData.accountType);
      }
      if (profileData.IFSCCode) setValue("IFSCCode", profileData.IFSCCode);
      if (profileData.UPICode) setValue("UPICode", profileData.UPICode);
      if (profileData.CKYCNumber)
        setValue("CKYCNumber", profileData.CKYCNumber);
      if (profileData.PANDocument)
        setValue("PANDocument", profileData.PANDocument);
      if (profileData.cancelledCheck)
        setValue("cancelledCheck", profileData.cancelledCheck);

      if (profileData.AADHARDocument)
        setValue("AADHARDocument", profileData.AADHARDocument);
    }
  };
  const getSpinnerData = async () => {
    const result = await insurerListController(true);
    setInsurer(result);
    const ctn = await countriesListController();
    setCountries(ctn);
    const bnk = await banksListController();
    setBankList(bnk);
    if (state?.payload) {
      const list = await statesListController(state.payload.countryId);
      setStateList(list);
    }
  };
  async function uploadHandler(key, userId, event) {
    setDocumentHill((prev) => ({
      ...prev,
      [key]: { ...prev[key], status: iDocumentStages.PICKED },
    }));
    console.log(documentHill);
    //upload document
    const result = await uploadProfileDocumentToAWS(
      event.target.files[0],
      userId
    );
    console.log("result", result);
    //if result then set the api result
    if (result !== null && result !== "undefined") {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: {
          ...prev[key],
          status: iDocumentStages.UPLOADED,
          url: result,
        },
      }));
    } else {
      setDocumentHill((prev) => ({
        ...prev,
        [key]: { ...prev[key], status: iDocumentStages.UPLOAD_FAILED },
      }));
    }
  }

  async function handleDocumentNew(event, target) {
    const userId = localStorage.getItem("userId");
    switch (target) {
      // case documentHill.panDoc.key:
      //   // set document for retry function
      //   setpanDoc(event);
      //   uploadHandler("panDoc", userId, event);

      //   break;
      // case documentHill.aadharDoc.key:
      //   setaadharDoc(event);
      //   uploadHandler("aadharDoc", userId, event);

      // break;

      case documentHill.orgMemoDocument.key:
        // set document for retry function
        setOrgMemoDoc(event);
        uploadHandler("orgMemoDocument", userId, event);

        break;
      case documentHill.orgPanDocument.key:
        // set document for retry function
        setorgPanDocument(event);
        uploadHandler("orgPanDocument", userId, event);

        break;
      case documentHill.orgRegistrationDocument.key:
        // set document for retry function
        setorgRegistrationDocument(event);
        uploadHandler("orgRegistrationDocument", userId, event);

        break;
      case documentHill.orgLossDocument.key:
        // set document for retry function
        setorgLossDocument(event);
        uploadHandler("orgLossDocument", userId, event);

        break;
      case documentHill.orgIncomeDocument.key:
        // set document for retry function
        setorgIncomeDocument(event);
        uploadHandler("orgIncomeDocument", userId, event);

        break;
      case documentHill.orgBalanceSheetDocument.key:
        // set document for retry function
        setorgBalanceSheetDocument(event);
        uploadHandler("orgBalanceSheetDocument", userId, event);

        break;
      case documentHill.orgAddressDocument.key:
        // set document for retry function
        setorgAddressDocument(event);
        uploadHandler("orgAddressDocument", userId, event);

        break;
      default:
        //   setcancelledChecqDoc(event);
        //   uploadHandler("cancelledChecqDoc", userId, event);

        break;
    }
  }

  function iretryFunction(document) {
    // if (documentHill.panDoc.key === document.key)
    //   handleDocumentNew(panDoc, documentHill.panDoc.key);
    // else if (documentHill.aadharDoc.key === document.key)
    //   handleDocumentNew(aadharDoc, document.key);
    // else if (documentHill.cancelledChecqDoc.key === document.key)
    //   handleDocumentNew(cancelledChecqDoc, document.key);
    if (documentHill.orgMemoDocument.key === document.key)
      handleDocumentNew(orgMemoDocument, documentHill.orgMemoDocument.key);
    else if (documentHill.orgPanDocument.key === document.key)
      handleDocumentNew(orgPanDocument, document.key);
    else if (documentHill.orgRegistrationDocument.key === document.key)
      handleDocumentNew(orgRegistrationDocument, document.key);
    else if (documentHill.orgLossDocument.key === document.key)
      handleDocumentNew(orgLossDocument, document.key);
    else if (documentHill.orgIncomeDocument.key === document.key)
      handleDocumentNew(orgIncomeDocument, document.key);
    else if (documentHill.orgBalanceSheetDocument.key === document.key)
      handleDocumentNew(orgBalanceSheetDocument, document.key);
    else if (documentHill.orgAddressDocument.key === document.key)
      handleDocumentNew(orgAddressDocument, document.key);
  }

  const genderChange = (value) => {
    errors.gender = false;
    setValue("gender", value);
  };
  const insurerChange = (insurerId) => {
    errors.insurerId = false;
    setValue("insurerId", parseInt(insurerId));
  };

  const countryChange = async (countryID) => {
    errors.countryId = false;
    setValue("countryId", parseInt(countryID));
    const list = await statesListController(countryID);
    setStateList(list);
  };
  const stateChange = (stateId) => {
    errors.stateId = false;
    setValue("stateId", parseInt(stateId));
  };
  const bankNameChange = (value) => {
    errors.bankId = false;
    setValue("bankId", parseInt(value));
  };
  const accountTypeChange = (type) => {
    errors.accountType = false;
    setValue("accountType", type);
  };
  const entityTypeChange = (data) => {
    errors.industryType = false;
    setValue("industryType", data);
  };
  const dateChange = (_, dateString) => {
    errors.orgRegistrationDate = false;
    setValue("orgRegistrationDate", dateString);
  };
  const isMobile = useMediaQuery({ query: "(max-width: 500px)" });

  const onSubmit = async (value) => {
    console.log("Values.before upload..", value);
    const id = localStorage.getItem("id");
    if (documentHill.panDoc.status === iDocumentStages.UPLOADED)
      value.PANDocument = documentHill.panDoc.url;
    if (documentHill.aadharDoc.status === iDocumentStages.UPLOADED)
      value.AADHARDocument = documentHill.aadharDoc.url;
    if (documentHill.cancelledChecqDoc.status === iDocumentStages.UPLOADED)
      value.cancelledCheck = documentHill.cancelledChecqDoc.url;
    if (documentHill.orgMemoDocument.status === iDocumentStages.UPLOADED)
      value.orgMemoDocument = documentHill.orgMemoDocument.url;
    if (documentHill.orgPanDocument.status === iDocumentStages.UPLOADED)
      value.orgPanDocument = documentHill.orgPanDocument.url;

    if (
      documentHill.orgRegistrationDocument.status === iDocumentStages.UPLOADED
    )
      value.orgRegistrationDocument = documentHill.orgRegistrationDocument.url;
    if (
      documentHill.orgBalanceSheetDocument.status === iDocumentStages.UPLOADED
    )
      value.orgBalanceSheetDocument = documentHill.orgBalanceSheetDocument.url;
    if (documentHill.orgIncomeDocument.status === iDocumentStages.UPLOADED)
      value.orgIncomeDocument = documentHill.orgIncomeDocument.url;

    if (documentHill.orgAddressDocument.status === iDocumentStages.UPLOADED)
      value.orgAddressDocument = documentHill.orgAddressDocument.url;

    if (documentHill.orgLossDocument.status === iDocumentStages.UPLOADED)
      value.orgLossDocument = documentHill.orgLossDocument.url;

    value.userType = "ENTITY";

    console.log("Values after upload...", value);
    if (state && state.payload) {
      AxiosInstance()
        .post("/auth/addNewRole", { userRole: "PARTNER" })
        .then((resp) => {
          localStorage.setItem("token", resp.data.token);
          AxiosInstance()
            .put("/profile", value)
            .then((resp) => {
              window.location.href = "/partnerDashboard";
            })
            .catch((err) => {
              alertError(err?.response?.data?.message);
            });
        })
        .catch((err) => {
          alertError(err?.response?.data?.message);
        });
      return;
    }
    AxiosInstance()
      .put("/profile", value)
      .then((resp) => {
        let { data } = resp;
        // localStorage.setItem("token", data.token);
        window.location.href = "/partnerDashboard";
      })
      .catch((err) => {
        alertError(err?.response?.data?.message);
      });
  };
  return (
    <>
      <form id="completePartnerEntityDetails" onSubmit={handleSubmit(onSubmit)}>
        <div class="row my-3 ">
          <h4 className="font-20 tre_font-bold">Entity Details</h4>
        </div>
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label htmlFor="nameOfOrganization">
                Entity Name {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                id="nameOfOrganization"
                name="nameOfOrganization"
                disabled={
                  profileData.nameOfOrganization && profileData.isUserVerified
                }
                className={`form-control ${
                  errors.nameOfOrganization ? " is-invalid" : ""
                }`}
                {...register("nameOfOrganization", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">Entity Name is required</div>
            </div>
          </div>
          <div class="col-md-6 md-form">
            <label htmlFor="industryType">
              Entity Type {<span style={{ color: "red" }}>*</span>}
            </label>
            <Controller
              name="industryType"
              control={control}
              errors={errors}
              rules={{ required: true }}
              render={({ field: { onChange, value, ref } }) => (
                <Select
                  placeholder="Select Entity Type"
                  value={getValues("industryType")}
                  disabled={
                    profileData.industryType && profileData.isUserVerified
                  }
                  onChange={entityTypeChange}
                  size="large"
                  className={`${errors.industryType ? "is-invalid" : ""}`}
                  options={industryTypeOptions}
                  style={{ width: "100%" }}
                />
              )}
            />

            <div className="invalid-feedback">Entity Type is required</div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6 md-form">
            <label htmlFor="orgPan">
              Entity PAN Number {<span style={{ color: "red" }}>*</span>}
            </label>
            <div className="input-group ">
              {" "}
              <input
                disabled={isOrgPanVerified}
                id="orgPan"
                type="text"
                maxlength={10}
                className={`form-control ${errors.orgPan ? "is-invalid" : ""}`}
                {...register("orgPan", {
                  required: true,
                  minLength: {
                    value: 10,
                    message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                  },
                  maxLength: {
                    value: 10,
                    message: "enter a valid pan number", // JS only: <p>error message</p> TS only support string
                  },
                })}
              />
              <div className="input-group-append">
                {isOrgPanVerified ? (
                  <span
                    className="input-group-text  rounded-0 "
                    id="basic-addon2"
                  >
                    <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                  </span>
                ) : (
                  <button
                    disabled={
                      (!getValues("orgPan") && !profileData.orgPan) ||
                      errors?.orgPan?.message
                    }
                    class="btn btn-outline-primary rounded-0 rounded-right "
                    type="button"
                    id="button-addon2"
                    onClick={() => {
                      setVerifyOrgPanModalState(true);
                    }}
                  >
                    Verify
                  </button>
                )}
              </div>
              <div className="invalid-feedback">{errors?.orgPan?.message}</div>
            </div>
          </div>
          <div class="col-md-6 md-form">
            <label htmlFor="orgRegistrationDate">
              Registration or Incorporation Date
            </label>
            <Controller
              name="orgRegistrationDate"
              control={control}
              errors={errors}
              rules={{ required: true }}
              render={(props) => (
                <DatePicker
                  inputReadOnly
                  type="text"
                  disabledDate={(current) => {
                    const startDate = moment().subtract(0, "years");
                    return startDate && current.valueOf() > startDate;
                  }}
                  disabled={
                    profileData.orgRegistrationDate &&
                    profileData.isUserVerified
                  }
                  defaultValue={
                    profileData.orgRegistrationDate
                      ? dayjs(profileData.orgRegistrationDate, "YYYY/MM/DD")
                      : ""
                  }
                  name="orgRegistrationDate"
                  className={`form-control tre_dobdate
                        ${errors.orgRegistrationDate ? " is-invalid" : ""}`}
                  onChange={dateChange}
                  {...props}
                />
              )}
            />

            <div className="invalid-feedback text-start font-14 mb-1">
              Incorporation Date is required
            </div>
          </div>
        </div>
        <div class="row mb-3">
          <div class="col-md-6 md-form">
            <label htmlFor="addressOfOrganization">Entity Address</label>
            <input
              type="text"
              disabled={
                profileData.addressOfOrganization && profileData.isUserVerified
              }
              className={`form-control ${
                errors.addressOfOrganization ? "is-invalid" : ""
              }`}
              id="addressOfOrganization"
              placeholder=""
              {...register("addressOfOrganization")}
            />
            <div className="invalid-feedback">Address is required</div>
          </div>
          <div class="col-md-6 md-form">
            <label htmlFor="annualIncome">
              Annual Income/ Profit After Tax
            </label>
            <input
              type="number"
              className={`form-control ${
                errors.annualIncome ? "is-invalid" : ""
              }`}
              id="annualIncome"
              disabled={
                profileData.annualIncome &&
                !AllowedProfileEditStatus.includes(profileData.status)
              }
              // aria-describedby="emailHelp"
              placeholder=""
              {...register("annualIncome", {
                pattern: {
                  value: /^\d+$/,
                  message: "Please enter a valid income",
                },
              })}
            />
            <div className="invalid-feedback">
              {errors.annualIncome && (
                <span>{errors?.annualIncome?.message}</span>
              )}
            </div>
          </div>
        </div>
        <div class="row mb-3 mt-5">
          <h4 className="font-20 tre_font-bold">
            Authorized Signatory Details
          </h4>
        </div>
        <div class="row mb-3">
          <div class="col-md-6 md-form">
            <label htmlFor="firstName">
              First Name {<span style={{ color: "red" }}>*</span>}
            </label>
            <input
              type="text"
              className={`form-control ${errors.firstName ? "is-invalid" : ""}`}
              id="firstName"
              disabled={
                profileData.firstName &&
                !AllowedProfileEditStatus.includes(profileData.status)
              }
              aria-describedby="firstName"
              placeholder=""
              {...register("firstName", {
                required: {
                  value: true,
                  message: "Enter First Name",
                },
              })}
            />
            <div className="invalid-feedback">First Name is required</div>
          </div>
          <div class="col-md-6 md-form">
            <label htmlFor="lastName">
              Last Name {<span style={{ color: "red" }}>*</span>}
            </label>
            <input
              type="text"
              className={`form-control ${errors.lastName ? "is-invalid" : ""}`}
              id="lastName"
              disabled={
                profileData.lastName &&
                !AllowedProfileEditStatus.includes(profileData.status)
              }
              aria-describedby="lastName"
              placeholder=""
              {...register("lastName", {
                required: {
                  value: true,
                  message: "Enter Last Name", // JS only: <p>error message</p> TS only support string
                },
              })}
            />
            <div className="invalid-feedback">Last Name is required</div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="pan" class="">
                PAN No. {<span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <input
                  disabled={isPanVerified}
                  type="text"
                  id="pan"
                  name="pan"
                  className={`form-control ${errors.pan ? " is-invalid" : ""}`}
                  {...register("pan", {
                    required: true,
                  })}
                />
                <div className="input-group-append">
                  {isPanVerified && (
                    <span
                      className="input-group-text  rounded-0 "
                      id="basic-addon2"
                    >
                      <i class="fa-solid fa-circle-check text-success py-1 fa-lg"></i>
                    </span>
                  )}
                </div>
              </div>

              <div className="invalid-feedback">Pan is required</div>
            </div>
          </div>
          <div class="col-md-6 md-form">
            <label htmlFor="firstName">
              Gender {<span style={{ color: "red" }}>*</span>}
            </label>

            <div className="input-group">
              <Controller
                name="gender"
                control={control}
                errors={errors}
                rules={{ required: true }}
                render={({ field: { onChange, value, ref } }) => (
                  <Select
                    value={getValues("gender")}
                    disabled={profileData.gender && profileData.isUserVerified}
                    onChange={genderChange}
                    size="large"
                    className={`${errors.gender ? "is-invalid" : ""}`}
                    options={genderOptions}
                    style={{ width: "100%" }}
                  />
                )}
              />

              <div className="invalid-feedback">Gender is required</div>
            </div>
          </div>
        </div>

        {/* <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="aadhar" class="">
                Aadhar No. {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                disabled={isAadhaarVerified}
                type="text"
                id="aadhar"
                name="aadhar"
                className={`form-control ${errors.aadhar ? " is-invalid" : ""}`}
                {...register("aadhar", {
                  required: true,
                  pattern: {
                    value: /^[0-9]*$/i,
                    message: "invalid value",
                  },
                })}
              />
              <div className="invalid-feedback">Aadhar is required</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="md-form">
              <label for="address" class="">
                Current Address {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                type="text"
                id="address"
                name="address"
                disabled={profileData.address && profileData.isUserVerified}
                className={`form-control ${
                  errors.address ? " is-invalid" : ""
                }`}
                {...register("address", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">Address is required</div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="countryId" class="">
                Country {<span style={{ color: "red" }}>*</span>}
              </label>
              <Controller
                name="countryId"
                control={control}
                errors={errors}
                rules={{ required: true }}
                render={(props) => (
                  <Select
                    className={`${errors.countryId ? "is-invalid" : ""}`}
                    value={getValues("countryId")}
                    disabled={
                      profileData.countryId && profileData.isUserVerified
                    }
                    onChange={countryChange}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {countries.map((item) => (
                      <Option key={item.countryId} value={item.countryId}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              />

              <div className="invalid-feedback">Country is required</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="md-form">
              <label for="state" class="">
                State {<span style={{ color: "red" }}>*</span>}
              </label>
              <Controller
                name="stateId"
                control={control}
                errors={errors}
                rules={{ required: true }}
                render={(props) => (
                  <Select
                    className={`${errors.stateId ? "is-invalid" : ""}`}
                    value={getValues("stateId")}
                    disabled={profileData.stateId && profileData.isUserVerified}
                    onChange={stateChange}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {stateList.map((item) => (
                      <Option key={item.stateId} value={item.stateId}>
                        {item.name}
                      </Option>
                    ))}
                  </Select>
                )}
              />

              <div className="invalid-feedback">State is required</div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="city" class="">
                City {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                disabled={profileData.city && profileData.isUserVerified}
                type="text"
                id="city"
                name="city"
                className={`form-control ${errors.city ? " is-invalid" : ""}`}
                {...register("city", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">City is required</div>
            </div>
          </div>

          <div class="col-md-6">
            <div class="md-form">
              <label for="pinCode" class="">
                Pin Code {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                disabled={profileData.pinCode && profileData.isUserVerified}
                type="text"
                id="pinCode"
                name="pinCode"
                className={`form-control ${
                  errors.pinCode ? " is-invalid" : ""
                }`}
                {...register("pinCode", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">Pincode is required</div>
            </div>
          </div>
        </div> */}
        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              {/* <label for="trePartnerpAddress" class="">
        Parmanent Address
      </label>
      <input
        type="text"
        id="trePartnerpAddress"
        name="trePartnerpAddress"
        class="form-control"
      /> */}
            </div>
          </div>
          <div class="col-md-6">
            <div class="md-form"></div>
          </div>
        </div>
        <div class="row my-3">
          <h4 className="font-20 tre_font-bold">Banking Details</h4>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="bankAccountNumber" class="">
                Bank Account Number {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                disabled={
                  profileData.bankAccountNumber && profileData.isUserVerified
                }
                type="text"
                id="bankAccountNumber"
                placeholder=""
                className={`form-control ${
                  errors.bankAccountNumber ? " is-invalid" : ""
                }`}
                {...register("bankAccountNumber", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">Account Number is required</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="md-form">
              <label htmlFor="bankName">
                Bank Name {<span style={{ color: "red" }}>*</span>}
              </label>
              <div className="input-group">
                <Controller
                  name="bankId"
                  control={control}
                  errors={errors}
                  rules={{ required: true }}
                  render={(props) => (
                    <Select
                      className={`${errors.bankId ? "is-invalid" : ""}`}
                      disabled={
                        profileData.bankId && profileData.isUserVerified
                      }
                      value={getValues("bankId")}
                      onChange={bankNameChange}
                      size="large"
                      style={{ width: "100%" }}
                    >
                      {bankList.map((item) => (
                        <Option key={item.bankId} value={item.bankId}>
                          {item.name}
                        </Option>
                      ))}
                    </Select>
                  )}
                />

                <div className="invalid-feedback">Bank Name is required</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label htmlFor="accountType">
                Account Type {<span style={{ color: "red" }}>*</span>}
              </label>
              <Controller
                name="accountType"
                control={control}
                errors={errors}
                rules={{ required: true }}
                render={(props) => (
                  <Select
                    className={`${errors.accountType ? "is-invalid" : ""}`}
                    disabled={
                      profileData.accountType && profileData.isUserVerified
                    }
                    value={getValues("accountType")}
                    onChange={accountTypeChange}
                    size="large"
                    style={{ width: "100%" }}
                  >
                    {getBankAccountType()}
                  </Select>
                )}
              />

              <div className="invalid-feedback">Account Type is required</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="md-form">
              <label for="CKYCNumber" class="">
                CKYC No.
              </label>
              <input
                disabled={
                  profileData.CKYCNumber &&
                  !AllowedProfileEditStatus.includes(profileData.status)
                }
                type="text"
                id="CKYCNumber"
                name="CKYCNumber"
                class="form-control"
                {...register("CKYCNumber", {})}
              />
            </div>
            {/* <div class="md-form">
      <label htmlFor="MICR ">MICR</label>
      <input
        type="text"
        id="MICR"
        name="MICR"
        className={`form-control ${
          errors.MICR ? " is-invalid" : ""
        }`}
        {...register("MICR", {
          required: true,
        })}
      />
      <div className="invalid-feedback">
        MICR Code is required
      </div>
    </div> */}
          </div>
        </div>
        <VerifyPanModal
          setActive={setVerifyOrgPanModalState}
          active={verifyOrgPanModalState}
          setPanVerified={setIsOrgPanVerified}
          idName={"ORG_PAN"}
          pan={getValues("orgPan")}
        ></VerifyPanModal>

        <div class="row mb-3">
          <div class="col-md-6">
            <div class="md-form">
              <label for="IFSCCode" class="">
                IFSC Code {<span style={{ color: "red" }}>*</span>}
              </label>
              <input
                disabled={profileData.IFSCCode && profileData.isUserVerified}
                type="text"
                id="IFSCCode"
                name="IFSCCode"
                className={`form-control ${
                  errors.IFSCCode ? " is-invalid" : ""
                }`}
                {...register("IFSCCode", {
                  required: true,
                })}
              />
              <div className="invalid-feedback">IFSC Code is required</div>
            </div>
          </div>
          <div class="col-md-6">
            <div class="md-form">
              <label for="UPICode" class="">
                UPI Id
              </label>
              <input
                disabled={
                  profileData.UPICode &&
                  !AllowedProfileEditStatus.includes(profileData.status)
                }
                type="text"
                id="UPICode"
                name="UPICode"
                class="form-control"
                {...register("UPICode", {})}
              />
            </div>
          </div>
        </div>

        <div class="row mb-3">
          <div class="col-md-6"></div>
          <div class="col-md-6">
            {/* <div class="md-form">
      <label for="EIANumber" class="">
        EIA No.
      </label>
      <input
        type="text"
        id="EIANumber"
        name="EIANumber"
        class="form-control"
        {...register("EIANumber", {})}
      />
    </div> */}
          </div>
        </div>

        <div class="row my-3">
          <h4 className="font-20 tre_font-bold">Attachment Doc</h4>
        </div>

        <Divider className="mt-0" />
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              {" "}
              {!profileData.orgMemoDocument && (
                <div className="mb-3 mt-2">
                  <label htmlFor="formFile" className="form-label">
                    Upload Copy of Memorandom/ AOA{" "}
                    <>
                      {documentWidget(
                        documentHill.orgMemoDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    id="orgMemoDocument"
                    accept={documentAccpetedTypes}
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgMemoDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
            <div class="col-md-6">
              {!profileData.orgPanDocument && (
                <div className="mb-3 mt-2">
                  <label htmlFor="formFile" className="form-label">
                    Upload Entity PAN{" "}
                    <>
                      {documentWidget(
                        documentHill.orgPanDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className={`form-control ${
                      errors.orgPanDocument ? "is-invalid" : ""
                    }`}
                    type="file"
                    id="orgPanDocument"
                    accept={documentAccpetedTypes}
                    onChange={(event) => {
                      handleDocumentNew(event, documentHill.orgPanDocument.key);
                    }}
                  />{" "}
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              {" "}
              {!profileData.orgRegistrationDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Registraion Certificate{" "}
                    <>
                      {documentWidget(
                        documentHill.orgRegistrationDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    id="orgRegistrationDocument"
                    accept={documentAccpetedTypes}
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgRegistrationDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
            <div class="col-md-6">
              {!profileData.orgAddressDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Address Proof{" "}
                    <>
                      {documentWidget(
                        documentHill.orgAddressDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    id="orgAddressDocument"
                    accept={documentAccpetedTypes}
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgAddressDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              {!profileData.orgIncomeDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Latest ITR Copy{" "}
                    <>
                      {documentWidget(
                        documentHill.orgIncomeDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    id="orgIncomeDocument"
                    accept={documentAccpetedTypes}
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgIncomeDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
            <div class="col-md-6">
              {!profileData.orgLossDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Profit & Loss Statement{" "}
                    <>
                      {documentWidget(
                        documentHill.orgLossDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    accept={documentAccpetedTypes}
                    id="orgLossDocument"
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgLossDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-md-6">
              {" "}
              {!profileData.orgBalanceSheetDocument && (
                <div className="mb-3">
                  <label htmlFor="formFile" className="form-label">
                    Upload Balance Sheet{" "}
                    <>
                      {documentWidget(
                        documentHill.orgBalanceSheetDocument,
                        iretryFunction
                      )}
                    </>
                  </label>
                  <input
                    className="form-control"
                    type="file"
                    accept={documentAccpetedTypes}
                    id="orgBalanceSheetDocument"
                    onChange={(event) => {
                      handleDocumentNew(
                        event,
                        documentHill.orgBalanceSheetDocument.key
                      );
                    }}
                  />{" "}
                </div>
              )}
            </div>
          </div>
        </div>
      </form>
      <button
        className="btn-block btn-holder btn-md mb-5"
        form="completePartnerEntityDetails"
      >
        Complete Profile
      </button>
    </>
  );
}
